<template>
  <div :class="classes">
    <!-- Remove file modal -->
      <b-modal
          id="reset-confirmation"
          title="Remover arquivo"
          class="modal-primary"
          @ok="reset()">
          Deseja remover esse arquivo? Ao confirmar essa ação o arquivo não poderá ser recuperado e deverá ser reenviado.
      </b-modal>
        <div class="col-lg-12 p-0">
          <b-card class="p-0">
            <label>
              {{ label }}
              <span v-if="requirements" class="text-muted text-sm">({{ requirements }})</span>
              </label>
            <div class="image-area" style="margin-top: 5px;">

              <div class="loading-upload-cloud" v-if="uploading">
              </div>

              <div v-if="errorImage" class="upload-image-error">
                <div class="error-lists">
                  <div class="pl-4">Erros:</div>
                  <ul class="pl-0">
                    <li v-if="extension.error">{{ extension.error }}</li>
                    <li v-if="fileSize.error">{{ fileSize.error }}</li>
                    <li v-for="sizeError in dimensions.errors" :key="sizeError">{{ sizeError }}</li>
                    <li class="text-center pl-0 pt-3" style="list-style: none">
                      <a @click="triggerUpload()" class="btn">
                        <i class="fa fa-upload d-inline align-middle"></i>
                        Tentar novamente
                      </a>
                      <a @click="cancelUpload()" class="btn">
                        <i class="fa fa-ban d-inline align-middle"></i>
                        Cancelar
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="image-area" :class="errorImage ? 'error-image-area' : ''">
                <input type="file" name="file" :id="fileId" @change="upload($event)"/>
                <div class="show-text-upload" v-show="!preview">
                  Clique aqui para fazer upload da imagem
                </div>
                <div class="cover-image" :style="'background-image: url(' + preview + ')'"></div>
                <div class="underbg" :style="'background-image: url(' + preview + ')'"></div>
              </div>
            </div>
            <span class="text-right pt-2 col-lg-12 pl-0 pr-0 float-right renew-image" :class="preview ? 'show-renew-image' : ''">
              <b-button variant="outline-light text-info" @click="triggerUpload()">
                <i class="fa fa-upload"></i>&nbsp;&nbsp;
                Alterar imagem
              </b-button>
              <b-button variant="outline-light text-danger" v-b-modal.reset-confirmation v-if="!errorImage">
                <i class="fa fa-trash"></i>&nbsp;&nbsp;
                Remover imagem
              </b-button>
            </span>
            <!-- <span v-if="requirements" class="upload-requirements pt-3" :class="errorImage ? 'text-danger danger' : ''">
              <i class="fa fa-info" v-if="!errorImage"></i>
              <i class="fa fa-exclamation-triangle" v-else></i>
              &nbsp;
              Requisitos: {{ requirements }}
            </span> -->
          </b-card>
        </div>
  </div>
</template>

<script>
  export default {
    props: {
      classes: {
        type: String,
        default: ''
      },
      requirements: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: 'Imagem'
      },
      extensions: {
        default: '.jpg,jpeg',
        type: String
      },
      maxFileSizeInMB: {
        default: '5',
        type: String
      },
      required: {
        type: Boolean,
        default: true
      },
      image: {
        type: String,
        default: ''
      }
    },
    name: 'Gallery',
    data () {
      return {
        items: [],
        uploading: false,
        dimensions: {
          width: 1280,
          height: 1280,
          between: true,
          errors: []
        },
        fileId: 'image-gallery-id',
        errorImage: false,
        preview: false,
        extension: {
          error: false
        },
        fileSize: {
          error: false
        }
      }
    },

    mounted () {
      if (this.image) {
        this.preview = this.image
      } else {
        var field = document.getElementById(this.fileId)
        field.oninvalid = function () {
          field.setCustomValidity('Faça o upload de uma imagem')
        }
        field.oninput = function () {
          field.setCustomValidity('')
        }
      }
    },

    methods: {
      triggerUpload () {
        var fileId = document.getElementById(this.fileId)
        fileId.click()
      },
      cancelUpload () {
        this.errorImage = false
      },
      reset () {
        this.errorImage = false
        this.preview = false
        document.getElementById(this.fileId).value = ''
      },
      validateExtensionImage (file) {
        var fileName = file.name.split('.')
        var ext = '.' + fileName[fileName.length - 1]
        var valid = false
        var extensions = this.extensions.split(',')

        extensions.forEach(item => {
          if (item === ext) {
            valid = true
          }
        })
        return (valid)
      },
      validateSizeImage (w, h, imageSize) {
        var self = this
        var widthSize = self.dimensions.width
        var heightSize = self.dimensions.height
        var msg = true

        self.dimensions.errors = []

        if (parseInt(imageSize) > parseInt(self.maxFileSizeInMB)) {
          self.fileSize.error = `O tamanho limite da imagem é de ${parseInt(self.maxFileSizeInMB)}MB, o tamanho da imagem enviada é de ${parseInt(imageSize)}MB.`
          return false
        }

        if (self.dimensions.between) {
          if (widthSize && widthSize < w && w < widthSize) {
            self.dimensions.errors.push('Largura da imagem inferior a ' + widthSize + 'px')
            msg = false
          }
          if (heightSize && heightSize < h && h < heightSize) {
            self.dimensions.errors.push('Altura da imagem inferior a ' + heightSize + 'px')
            msg = false
          }
        } else {
          if (widthSize && widthSize > w) {
            self.dimensions.errors.push('Largura da imagem inferior a ' + widthSize + 'px')
            msg = false
          }
          if (heightSize && heightSize > h) {
            self.dimensions.errors.push('Altura da imagem inferior a ' + heightSize + 'px')
            msg = false
          }
          // Imagem maior
          if (widthSize && widthSize < w) {
            self.dimensions.errors.push('Largura da imagem superior a ' + widthSize + 'px')
            msg = false
          }
          if (heightSize && heightSize < h) {
            self.dimensions.errors.push('Altura da imagem superior a ' + heightSize + 'px')
            msg = false
          }
        }
        return msg
      },
      convertSizeToMB (bytes) {
        return bytes / 1e+6
      },
      upload (inpt) {
        var reader = new FileReader()
        var self = this
        var file = inpt.target.files[0]
        self.extension.error = false
        self.fileSize.error = false
        self.dimensions.errors = []

        if (!this.validateExtensionImage(file)) {
          self.errorImage = true
          self.extension.error = 'Extensão de imagem inválida'
          return
        }

        this.uploading = true

        reader.onloadend = function () {
          var img = new Image()
          img.src = reader.result
          img.onload = function () {
            var w = (this.width)
            var h = (this.height)
            var imageSize = self.convertSizeToMB(file.size)
            if (self.validateSizeImage(w, h, imageSize)) {
              self.preview = reader.result
              self.errorImage = false
              self.uploading = false
              self.$emit('update', file)
            } else {
              self.errorImage = true
              self.uploading = false
            }
          }
        }

        if (file) {
          reader.readAsDataURL(file)
        } else {
          self.errorImage = true
        }
      }
    }
  }
</script>

<style lang="scss">
  .content-gallery-component {
    float: left;
    width: 100%;
    padding: 8px;
    background: #f7f8f9;
    border: 1px solid #eee;
  }
  .modal-dialog.modal-md {
    z-index: 999999;
  }
  .upload-requirements {
    float: left;
    width: 100%;
    padding-top: 4px;
    margin-top: 4px;
    border-top: 1px solid #eee;
  }
  .renew-image {
    overflow: hidden;
    height: 0;
    transition: 0.600s ease-in-out;
    opacity: 0;

    a {
      font-size: 12px;
    }

    &.show-renew-image {
      height: 45px;
      opacity: 1;
    }
  }

  .error-image-area {
    filter: blur(9px)
  }

  .upload-image-error {
    background: rgba(101, 6, 6, 0.63);
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
    color: #fff;
    font-weight: bold;
    padding: 20px;
    z-index: 99;
    .error-lists {
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      transform: translateY(-50%);
      ul {
        padding-top: 10px;
        li {
          margin-bottom: 9px;
          padding-left: 40px;

        }
      }
    }
  }

  .image-area {

    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    width: 100%;
    height: 220px;
    float: left;
    overflow: hidden;
    position: relative;
    border: 2px solid #ffffff;
    box-shadow: 0px 0px 2px 3px #dedede73, inset 0px 0px 6px rgba(0, 0, 0, 0.08);
    background-color: rgba(238, 238, 238, 0.57);
    transition: background-image 0.2s ease-in-out;

    &:hover {
      border: 2px dashed #c3ddfd;
      -webkit-box-shadow: 0px 0px 2px 3px #a9cdf373;
      box-shadow: 0px 0px 2px 3px #c5e4fb73;
      background-color: rgba(208, 222, 230, 0.57);
      &:before {
        color: #000;
        text-decoration: underline;
      }
    }

    .show-text-upload {
      width: 100%;
      top: 50%;
      transform: translateY(-50%);
      position: absolute;
      text-align: center;
      font-weight: bolder;
      font-size: 15px;
      color: #39393a;
      z-index: 0;

    }

    .underbg, .cover-image {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 0;
      background-size: cover;
      background-position: center;
      -webkit-transition: background-image 0.2s ease-in-out;
      transition: background-image 0.2s ease-in-out;
      filter: blur(70px);
    }

    .cover-image {
      filter: none;
      z-index: 99;
      background-repeat: no-repeat;
      background-size: contain;
    }

    input {
      cursor: pointer;
      opacity: 0;
      top: 0;
      left: 0;
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 999;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/GalleryComponent.vue